{
  "common": {
    "search": "Cari...",
    "filter": "Filter",
    "all": "Semua",
    "actions": "Aksi",
    "view": "Lihat",
    "viewDetails": "Lihat Rincian",
    "edit": "Ubah",
    "delete": "Hapus",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "saveChanges": "Simpan Perubahan",
    "download": "Unduh",
    "print": "Cetak",
    "status": "Status",
    "date": "Tanggal",
    "amount": "Nominal",
    "total": "Total",
    "currency": "Mata Uang",
    "notes": "Catatan",
    "loading": "Memuat...",
    "noData": "Tidak ada data yang tersedia",
    "success": "Berhasil",
    "error": "Terjadi Kesalahan",
    "close": "Tutup",
    "submit": "Kirim",
    "branch": "Kantor Cabang",
    "previous": "Sebelumnya",
    "next": "Selanjutnya",
    "critical": "Kritis",
    "active": "Aktif",
    "target": "Target",
    "completed": "Selesai",
    "finalized": "Selesai",
    "inProgress": "Dalam Proses",
    "pastDue": "Jatuh Tempo",
    "voided": "Dibatalkan",
    "corporate": "Korporat",
    "current": "Saat Ini",
    "statusApproved": "Disetujui",
    "statusDraft": "Draf",
    "statusPending": "Menunggu",
    "statusOverdue": "Lewat Jatuh Tempo",
    "statusPaid": "Lunas",
    "statusPartial": "Bayar Sebagian",
    "statusDeposit": "DP Diterima",
    "statusCancelled": "Dibatalkan",
    "statusRejected": "Ditolak",
    "statusTentative": "Sementara (Tentatif)",
    "statusConfirmed": "Dikonfirmasi",
    "updatedBy": "Diperbarui Oleh",
    "close": "Tutup",
    "yes": "Ya",
    "no": "Tidak",
    "downloadImage": "Unduh Gambar",
    "selected": "dipilih",
    "exportSelected": "Ekspor Terpilih",
    "deleteSelected": "Hapus Terpilih",
    "noFile": "Tidak ada file",
    "done": "Selesai",
    "refresh": "Segarkan",
    "copied": "Tersalin!",
    "copiedConfirmation": "Nomor konfirmasi berhasil disalin",
    "generateReceipt": "Buat Kuitansi",
    "generateDepositReceipt": "Buat Kuitansi Uang Muka",
    "directDepositReceipt": "Kuitansi Deposit Langsung",
    "viewStandaloneReceipts": "Lihat Daftar Kuitansi Langsung",
    "downloadReceipt": "Unduh Kuitansi",
    "officialReceipt": "Kuitansi Resmi",
    "depositReceipt": "Kuitansi Uang Muka",
    "receiptNo": "No. Kuitansi"
  },
  "nav": {
    "overview": "Ikhtisar",
    "external": "Eksternal",
    "internal": "Internal",
    "others": "Lainnya",
    "dashboard": "Dashboard",
    "confirmations": "Konfirmasi",
    "invoices": "Konfirmasi",
    "requests": "Permintaan",
    "companies": "Perusahaan",
    "hotelReservations": "Reservasi Hotel",
    "myExpenses": "Pengeluaran Saya",
    "submitExpense": "Ajukan Pengeluaran",
    "approvals": "Persetujuan Klaim",
    "settings": "Pengaturan",
    "superAdmin": "Super Admin",
    "comingSoon": "segera hadir"
  },
  "header": {
    "operatingBranch": "Kantor Cabang:",
    "notifications": "Notifikasi",
    "all": "Semua",
    "systemLog": "Log Sistem",
    "markAllRead": "Tandai semua sudah dibaca",
    "noNotifications": "Tidak ada notifikasi pada kategori ini.",
    "settings": "Pengaturan",
    "switchAccount": "Ganti Akun",
    "language": "Bahasa",
    "superAdminDashboard": "Dashboard Super Admin",
    "logOut": "Keluar"
  },
  "dashboard": {
    "welcome": "Selamat Datang",
    "systemName": "Sistem Keuangan ODST Group",
    "totalRevenue": "Total Pendapatan",
    "totalConfirmations": "Total Konfirmasi",
    "pendingApprovals": "Menunggu Persetujuan",
    "outstandingBalance": "Sisa Piutang Berjalan",
    "overdueBalance": "Piutang Lewat Jatuh Tempo",
    "recentConfirmations": "Konfirmasi Terbaru",
    "seeAllConfirmations": "Lihat Semua Konfirmasi",
    "approvalQueue": "Antrean Persetujuan",
    "awaitingReview": "Menunggu Peninjauan",
    "actionRequired": "Perlu Tindakan",
    "branchPerformance": "Kinerja Cabang",
    "revenueShare": "Pangsa Pendapatan",
    "revenueShareLabel": "Pangsa Pendapatan",
    "monthlyRevenueTrend": "Tren Pendapatan Bulanan",
    "quarterlyGrowth": "Pertumbuhan Triwulan",
    "ref": "No. Referensi",
    "client": "Klien / Perusahaan",
    "confDate": "Tgl Konfirmasi",
    "dueDate": "Jatuh Tempo",
    "acrossAllOffices": "Di seluruh cabang operasional aktif",
    "activeLedgerRecords": "Data buku besar aktif",
    "requiresReview": "Memerlukan peninjauan",
    "pendingSettlement": "Menunggu pelunasan",
    "overdueConfirmation": "konfirmasi lewat jatuh tempo",
    "overdueConfirmations": "konfirmasi lewat jatuh tempo",
    "financialReport": "Laporan Keuangan",
    "performanceSummary": "Ringkasan Kinerja",
    "growthQoQ": "Pertumbuhan (QoQ)",
    "outstanding": "Sisa Tagihan (Outstanding)",
    "quarterlyFinancialComparison": "Perbandingan Keuangan Kuartalan",
    "metric": "Metrik",
    "change": "Perubahan",
    "revenue": "Pendapatan",
    "netProfit": "Laba Bersih",
    "profitMargin": "Margin Laba",
    "invoiceDistributionOverview": "Ikhtisar Distribusi Faktur",
    "totalSent": "Total Terkirim",
    "dataConsolidatedFor": "Data terkonsolidasi untuk",
    "exportPdfReport": "Ekspor Laporan PDF"
  },
  "invoices": {
    "title": "Buku Besar Konfirmasi",
    "subtitle": "Pantau pembayaran uang muka, pencatatan deposit, rincian termin cicilan, dan saldo kredit lebih bayar.",
    "createConfirmation": "Buat Konfirmasi Baru",
    "exportCsv": "Ekspor CSV",
    "batchDelete": "Hapus Terpilih",
    "searchPlaceholder": "Cari berdasarkan no. konfirmasi, ref, klien, atau perusahaan...",
    "recentApprovedConfirmations": "Konfirmasi Disetujui Terbaru",
    "allBranches": "Semua Cabang",
    "allStatuses": "Semua Status",
    "allCompanies": "Semua Perusahaan",
    "awaitingClearance": "Menunggu Kliring",
    "clearedSubtext": "Berhasil diproses & diselesaikan",
    "serialNo": "No. Seri",
    "paidAmount": "Sudah Dibayar",
    "remaining": "Sisa Tagihan",
    "advancePayment": "Uang Muka (DP)",
    "addPayment": "Catat Pembayaran",
    "paymentHistory": "Riwayat Pembayaran",
    "recordNewPayment": "Catat Pembayaran Baru",
    "paymentDate": "Tanggal Pembayaran",
    "paymentProof": "Bukti Pembayaran / Transfer",
    "creditBalanceExcess": "Simpan kelebihan pembayaran sebagai saldo kredit klien",
    "itemizedCharges": "Rincian Biaya Layanan",
    "serviceDescription": "Deskripsi Layanan",
    "unitPrice": "Harga Satuan",
    "qty": "Jumlah",
    "subtotal": "Subtotal",
    "showing": "Menampilkan",
    "of": "dari",
    "approvedInvoices": "konfirmasi disetujui",
    "confirmationDetails": "Rincian Konfirmasi",
    "reviewBillingDetails": "Tinjau rincian penagihan",
    "generateNewConfirmation": "Buat Konfirmasi Baru",
    "editConfirmation": "Ubah Konfirmasi",
    "modifyConfirmationSubtitle": "Ubah rincian konfirmasi sebelum diajukan kembali",
    "confirmationNumber": "Nomor Konfirmasi",
    "referenceNumber": "Nomor Referensi",
    "serialNumber": "Nomor Seri",
    "confirmationDate": "Tanggal Konfirmasi",
    "dueDate": "Jatuh Tempo",
    "billFrom": "Ditagihkan Dari",
    "billTo": "Ditagihkan Kepada",
    "clientCompany": "Perusahaan Klien",
    "clientSelection": "Pilihan Nama Perusahaan / Klien",
    "selectClientCompany": "Pilih perusahaan klien...",
    "pleaseSelectCompany": "Silakan pilih perusahaan",
    "entityCompany": "Entitas / Perusahaan",
    "companyTaxNumber": "NPWP / Nomor Pajak Perusahaan",
    "streetAddress": "Alamat Jalan",
    "cityCountry": "Kota / Negara",
    "phone": "Nomor Telepon",
    "description": "Deskripsi Layanan",
    "itemizedCharges": "Rincian Biaya Layanan",
    "itemDescription": "Deskripsi Layanan",
    "qty": "Jumlah",
    "unitPrice": "Harga Satuan",
    "total": "Total",
    "subtotal": "Subtotal",
    "totalDue": "Total Tagihan",
    "taxVat": "Pajak / PPN",
    "hasAdvancePayment": "Ada Uang Muka (DP)?",
    "advancePaymentAmount": "Jumlah Uang Muka (DP)",
    "selectService": "Pilih Layanan",
    "chooseConfiguredService": "Pilih layanan terkonfigurasi...",
    "addCustomItem": "Tambah Item Khusus",
    "paymentInstructions": "Instruksi Pembayaran",
    "bankName": "Nama Bank",
    "accountName": "Nama Rekening",
    "idrAccountNumber": "Nomor Rekening IDR",
    "usdAccountNumber": "Nomor Rekening USD",
    "bankBranchAddress": "Alamat Cabang Bank",
    "cifNumber": "Nomor CIF / Identitas Bank",
    "swiftCode": "Kode SWIFT",
    "notes": "Catatan",
    "termsAndConditions": "Syarat & Ketentuan",
    "systemStatus": "Status sistem",
    "viewPaymentProof": "Lihat Bukti Bayar",
    "uploadProof": "Unggah Bukti",
    "print": "Cetak",
    "downloadPdf": "Unduh PDF",
    "verifying": "Memverifikasi...",
    "errorsFound": "kesalahan ditemukan. Harap perbaiki sebelum mengirim.",
    "dueDateFuture": "Tanggal jatuh tempo harus di masa depan",
    "validationFailed": "Validasi gagal: Perbaiki kesalahan untuk melanjutkan",
    "formStatusValid": "Status formulir: Valid & lengkap",
    "saveAndResubmit": "Simpan & Ajukan Ulang",
    "generateConfirmation": "Buat Konfirmasi",
    "currency": "Mata Uang",
    "noCompaniesAvailable": "Tidak ada perusahaan yang tersedia. Silakan tambahkan perusahaan di Pengaturan atau halaman Perusahaan terlebih dahulu.",
    "agent": "Agent",
    "othersClient": "Lainnya / Klien Manual (Others)",
    "customClientInfo": "Klien Khusus (Tanpa Simpan ke Master Data)",
    "customCompanyNameRequired": "Nama perusahaan klien wajib diisi",
    "additionalInformation": "Informasi Tambahan (Opsional)",
    "additionalInformationDesc": "Detail nomor grup dan kewarganegaraan tamu opsional.",
    "groupNumber": "Nomor Grup",
    "groupNumberPlaceholder": "cth. GRP-2026-JKT01",
    "nationality": "Kewarganegaraan",
    "nationalityPlaceholder": "cth. Indonesia / Saudi",
    "paymentHistoryTitle": "Riwayat Pembayaran & Pengelolaan Saldo",
    "confirmation": "Konfirmasi",
    "totalBilled": "Total Tagihan",
    "totalPaid": "Total Dibayar",
    "remainingDue": "Sisa Tagihan",
    "installmentsLedger": "Buku Besar Angsuran",
    "addPayment": "Tambah Pembayaran",
    "addPaymentApprovalNote": "🔒 Penambahan pembayaran terbuka setelah Persetujuan Tingkat 4",
    "date": "Tanggal",
    "amount": "Jumlah",
    "recordedBy": "Dicatat Oleh",
    "proof": "Bukti",
    "viewProof": "Lihat Bukti",
    "noInstallmentsRecorded": "Belum ada pembayaran angsuran yang dicatat.",
    "editPaymentRecord": "Ubah Catatan Pembayaran",
    "recordNewPayment": "Catat Pembayaran Baru",
    "paymentAmount": "Jumlah Pembayaran",
    "enterAmountPaid": "Masukkan jumlah yang dibayarkan...",
    "paymentDate": "Tanggal Pembayaran",
    "uploadPaymentProof": "Unggah Bukti Pembayaran (Struk Transfer)",
    "attachProofFile": "Lampirkan bukti (Gambar/PDF)...",
    "paymentNote": "Catatan Pembayaran (Opsional)",
    "paymentNotePlaceholder": "Contoh: Transfer bank, nomor referensi struk...",
    "overpaymentDetected": "Kelebihan Pembayaran Terdeteksi (+{{amount}})",
    "saveExcessCredit": "Simpan kelebihan sebagai saldo kredit untuk {{company}}?",
    "savePayment": "Simpan Pembayaran",
    "deletePaymentConfirmTitle": "Hapus Catatan Pembayaran?",
    "deletePaymentConfirmDesc": "Apakah Anda yakin ingin menghapus catatan pembayaran ini? Sisa tagihan akan dihitung ulang secara otomatis.",
    "uploadingPaymentProof": "Mengunggah Bukti Pembayaran",
    "convertingImage": "Mengonversi gambar dan mengunggah ke server. Harap tunggu...",
    "paymentProofViewerTitle": "Foto Bukti Transfer / PDF",
    "downloadImage": "Unduh Gambar",
    "confirmationAutoApproved": "Konfirmasi Disetujui Otomatis",
    "bypassApprovedDesc": "Bypass langsung aktif. Konfirmasi Anda telah disetujui dan siap diunduh.",
    "confirmationGeneratedSuccess": "Konfirmasi Berhasil Dibuat",
    "confirmationGeneratedDesc": "Konfirmasi Anda telah dibuat. Apakah Anda ingin mengirim permintaan persetujuan untuk pembayaran?",
    "noThanks": "Tidak, Terima Kasih",
    "sendRequest": "Kirim Permintaan",
    "requestSentSuccess": "Permintaan Berhasil Dikirim",
    "requestSentDesc": "Permintaan persetujuan Anda telah berhasil dikirim. Anda akan diberitahu setelah disetujui.",
    "viewPdf": "Lihat / PDF"
  },
  "requests": {
    "title": "Permintaan Persetujuan",
    "subtitle": "Tinjau, setujui, atau tolak permohonan persetujuan layanan dan faktur bertingkat.",
    "allRequests": "Semua Permintaan",
    "allRequestsListing": "Daftar Semua Permintaan Konfirmasi",
    "myApprovals": "Persetujuan Saya",
    "approved": "Telah Disetujui",
    "rejected": "Ditolak",
    "searchPlaceholder": "Cari permintaan atau perusahaan...",
    "level1": "Chief Accountant (L1)",
    "level2": "Approver (L2)",
    "level3": "Division Director (L3)",
    "level4": "Financial Controller (L4)",
    "approve": "Setujui",
    "reject": "Tolak",
    "approvalNote": "Catatan Persetujuan",
    "rejectionReason": "Alasan Penolakan",
    "provideReason": "Mohon berikan alasan penolakan secara jelas",
    "submittedBy": "Diajukan Oleh",
    "submissionDate": "Tanggal Pengajuan",
    "showing": "Menampilkan",
    "of": "dari",
    "totalRequests": "total permintaan",
    "fullyApprovedBanner": "Konfirmasi ini telah disetujui penuh dan siap untuk proses pembayaran. Seluruh tanda tangan yang diperlukan telah lengkap.",
    "rejectedConfirmationDetails": "Detail Konfirmasi yang Ditolak",
    "fullyApprovedConfirmationDetails": "Detail Konfirmasi yang Disetujui Penuh",
    "reviewRequest": "Tinjau Permintaan",
    "confirmationRequests": "Permintaan Konfirmasi",
    "requestNumber": "Permintaan",
    "backToListing": "Kembali ke Daftar",
    "approvalWorkflow": "Alur Kerja Persetujuan",
    "approvalWorkflowStatus": "Status Alur Kerja Persetujuan",
    "awaitingReview": "Menunggu Peninjauan",
    "pending": "Tertunda",
    "chiefAccountant": "Chief Accountant",
    "level2Approvers": "Level 2 Approvers",
    "level3Approvers": "Level 3 Approvers",
    "umrahDivisionDirector": "Direktur Divisi Umrah",
    "financialController": "Financial Controller",
    "approvalsComplete": "Persetujuan Lengkap",
    "readyForPayment": "Siap untuk eksekusi pembayaran.",
    "requestRejected": "Permintaan Ditolak",
    "approvalsProgress": "{{count}} dari 4 Persetujuan Selesai",
    "pendingLevelAction": "Menunggu tindakan Level {{level}} sebelum melanjutkan.",
    "waitingForLevel": "Menunggu persetujuan Level {{level}}",
    "awaitingReviewYourLevel": "Menunggu Peninjauan (Tingkat Anda)",
    "paymentTransferPhoto": "Foto Bukti Transfer Pembayaran",
    "paymentProofPdf": "PDF Bukti Pembayaran",
    "clickToViewPdf": "Klik untuk Melihat Dokumen PDF",
    "clickToViewFullSize": "🔍 Klik untuk Melihat Ukuran Penuh",
    "deleteProof": "Hapus Bukti",
    "changeDocument": "Ganti Dokumen",
    "noProofUploaded": "Belum ada dokumen bukti pembayaran yang diunggah.",
    "uploadProofPdfImg": "Unggah Bukti (PDF/Gambar)",
    "availableOperations": "Operasi yang Tersedia",
    "reviewPaymentInstructions": "Mr. Emad, mohon periksa bukti pembayaran yang diunggah di bawah ini. Jika bukti sudah benar, setujui pembayaran.",
    "rejectPayment": "Tolak Pembayaran",
    "approvePayment": "Setujui Pembayaran",
    "awaitingPaymentApprovalNotice": "Bukti pembayaran telah diunggah dan diajukan. Menunggu persetujuan dari Mr. Emad Moustafa.",
    "markedAsPaid": "Ditandai Lunas",
    "executePayment": "Eksekusi Pembayaran",
    "submitPaymentForApproval": "Ajukan Pembayaran untuk Persetujuan",
    "sendConfirmation": "Kirim Konfirmasi",
    "printConfirmation": "Cetak Konfirmasi",
    "downloadPdf": "Unduh PDF",
    "editAndResubmit": "Edit dan Ajukan Ulang",
    "archiveConfirmation": "Arsipkan Konfirmasi",
    "decisionInfo": "Harap tinjau semua rincian dengan cermat sebelum mengambil keputusan. Tindakan ini tidak dapat dibatalkan.",
    "yourDecision": "Keputusan Anda (Level {{level}})",
    "decisionSubtitle": "Sebagai {{role}}, konfirmasi atau tolak permintaan konfirmasi ini.",
    "approvalNoteOptional": "Catatan Persetujuan (Opsional)",
    "addNotePlaceholder": "Tambahkan catatan opsional untuk menyertai keputusan Anda...",
    "approveAndSign": "Setujui & Tanda Tangani Konfirmasi",
    "rejectRequest": "Tolak Permintaan",
    "employeeName": "Nama Karyawan",
    "employeeId": "ID Karyawan",
    "companyEmail": "Email Perusahaan",
    "sendConfirmationToClient": "Kirim Konfirmasi ke Klien",
    "sendConfirmationDesc": "Tindakan ini akan secara otomatis membuat dokumen konfirmasi HTML yang berdesain rapi dan mengirimkannya langsung ke email penagihan pelanggan.",
    "recipientEmailAddress": "Alamat Email Penerima",
    "sendEmail": "Kirim Email",
    "sending": "Mengirim...",
    "confirmationSent": "Konfirmasi Terkirim!",
    "confirmationSentDesc": "Email konfirmasi telah berhasil dikirimkan ke",
    "paymentPhotoPdf": "Foto Bukti Transfer / Dokumen PDF",
    "downloadImage": "Unduh Gambar",
    "areYouSure": "Apakah Anda yakin?",
    "confirmMarkPaid": "Apakah Anda ingin menandai konfirmasi ini sebagai lunas?",
    "yesConfirm": "Ya, Konfirmasi",
    "confirmationMarkedAsPaid": "Konfirmasi Ditandai Lunas!",
    "transactionRecorded": "Transaksi telah berhasil dicatat ke dalam sistem.",
    "archiveRequestTitle": "Arsipkan Permintaan?",
    "archiveRequestDesc": "Apakah Anda yakin ingin mengarsipkan permintaan faktur ini? Tindakan ini tidak dapat dibatalkan.",
    "yesArchive": "Ya, Arsipkan",
    "confirmationArchived": "Permintaan Konfirmasi Diarsipkan!",
    "confirmationArchivedDesc": "Permintaan konfirmasi telah berhasil diarsipkan.",
    "provideRejectionReason": "Berikan Alasan Penolakan",
    "reasonOfRejection": "Alasan Penolakan",
    "rejectionReasonPlaceholder": "Masukkan alasan mengapa faktur ini ditolak..."
  },
  "companies": {
    "title": "Direktori Perusahaan Rekanan",
    "subtitle": "Kelola profil perusahaan mitra, saldo kredit klien, riwayat transaksi, dan informasi kontak.",
    "addCompany": "Tambah Perusahaan Baru",
    "addNewCompany": "Tambah Perusahaan Baru",
    "editCompanyDetails": "Ubah Detail Perusahaan",
    "companyDetails": "Detail Perusahaan",
    "companyCode": "Kode Perusahaan",
    "companyName": "Nama Perusahaan",
    "phoneNumber": "Nomor Telepon",
    "streetAddress": "Alamat Jalan",
    "city": "Kota",
    "postalCode": "Kode Pos",
    "country": "Negara",
    "taxIdentificationNumber": "Nomor Pokok Wajib Pajak (NPWP / Tax ID)",
    "agent": "Agent",
    "noAgent": "Tidak Ada (Tanpa Agent)",
    "unique3LetterIdentifier": "Kode pengenal 3-5 huruf unik",
    "creditBalance": "Saldo Kredit",
    "resetCredit": "Reset Saldo",
    "resetCreditConfirm": "Reset saldo kredit untuk {{name}} ke SAR 0.00?",
    "resetCreditSuccess": "Saldo kredit berhasil direset ke 0.",
    "address": "Alamat Kantor",
    "cityCountry": "Kota / Negara",
    "taxNo": "Nomor NPWP / Pajak",
    "taxId": "Nomor NPWP / Pajak",
    "contactAgent": "Agent",
    "searchPlaceholder": "Cari nama perusahaan, kode, atau kota...",
    "financialReport": "Laporan Keuangan",
    "registeredRegions": "Terdaftar di semua wilayah",
    "corporate": "Korporat",
    "showing": "Menampilkan",
    "of": "dari",
    "registeredCompanies": "perusahaan terdaftar",
    "noCompaniesRegistered": "Belum ada perusahaan terdaftar",
    "noCompaniesRegisteredDesc": "Tambahkan perusahaan rekanan pertama Anda untuk mulai membuat faktur.",
    "noCompaniesFound": "Perusahaan tidak ditemukan",
    "noCompaniesFoundDesc": "Coba sesuaikan kata kunci pencarian Anda.",
    "nameRequired": "Nama Perusahaan wajib diisi",
    "codeRequired": "Kode Perusahaan wajib diisi",
    "phoneRequired": "Nomor Telepon wajib diisi",
    "addressRequired": "Alamat Jalan wajib diisi",
    "cityRequired": "Kota wajib diisi",
    "postalRequired": "Kode Pos wajib diisi",
    "taxRequired": "Nomor Pajak/NPWP wajib diisi",
    "codeAlreadyExists": "Kode Perusahaan sudah digunakan",
    "deleteCompany": "Hapus Perusahaan",
    "deleteCompanyTitle": "Hapus Perusahaan?",
    "deleteCompanyConfirm": "Apakah Anda yakin ingin menghapus {{name}} ({{code}})? Tindakan ini akan menghapus perusahaan secara permanen.",
    "yesDelete": "Ya, Hapus",
    "editDetails": "Ubah Rincian",
    "saveChanges": "Simpan Perubahan",
    "companyFinancialReport": "Laporan Keuangan Perusahaan",
    "financialSummary": "Ringkasan Keuangan",
    "totalRevenue": "TOTAL PENDAPATAN",
    "netProfit": "LABA BERSIH",
    "outstanding": "TAGIHAN BELUM DIBAYAR",
    "monthlyFinancialOverview": "IKHTISAR KEUANGAN BULANAN",
    "companyFinancialBreakdown": "RINCIAN KEUANGAN PERUSAHAAN",
    "month": "BULAN",
    "revenue": "PENDAPATAN",
    "invoicesSent": "FAKTUR TERKIRIM",
    "invoicesPaid": "FAKTUR LUNAS",
    "amountPaid": "JUMLAH DIBAYAR",
    "pending": "PENDING",
    "overdue": "JATUH TEMPO",
    "dataConsolidated": "Data dikonsolidasikan untuk semua perusahaan",
    "exportPdfReport": "Ekspor Laporan PDF",
    "confirmAddCompany": "Apakah Anda yakin ingin menambahkan {{name}} ke dalam sistem?",
    "successfullyDeleted": "Berhasil Dihapus",
    "deletedDesc": "{{name}} telah berhasil dihapus dari sistem.",
    "successfullyAdded": "Berhasil Ditambahkan",
    "addedDesc": "{{name}} telah berhasil ditambahkan ke dalam daftar sistem."
  },
    "hotelReservations": {
      "title": "Reservasi Hotel",
      "subtitle": "Pantau voucher reservasi hotel, alokasi tipe kamar, tanggal check-in/out, dan pelacakan deposit.",
      "tabReservations": "Daftar Reservasi",
      "tabRequests": "Permintaan Reservasi",
      "newReservation": "Reservasi Baru",
      "createTentative": "Reservasi Tentatif",
      "createConfirmation": "Reservasi Konfirmasi",
      "allReservations": "Daftar Semua Reservasi",
      "searchPlaceholder": "Cari berdasarkan no. reservasi, nama tamu, atau hotel...",
      "totalBooked": "Total dipesan",
      "totalReservations": "total reservasi",
      "reservations": "reservasi",
      "showing": "Menampilkan",
      "hotel": "Hotel",
      "guestName": "Nama Tamu / Jamaah",
      "checkIn": "Check-In",
      "checkOut": "Check-Out",
      "rooms": "Jumlah Kamar",
      "roomType": "Tipe Kamar",
      "nights": "Malam",
      "resNo": "No. Reservasi",
      "reqNo": "No. Permintaan",
      "amount": "Nominal",
      "expiredPayment": "Pembayaran kedaluwarsa",
      "manuallyCancelled": "Dibatalkan manual",
      "allRequests": "Semua Permintaan",
      "pendingRequests": "Menunggu",
      "confirmedRequests": "Dikonfirmasi",
      "rejectedRequests": "Ditolak",
      "noBookingsFound": "Reservasi tidak ditemukan",
      "noBookingsFoundDesc": "Tidak ada catatan yang sesuai dengan pencarian Anda.",
      "hotelReservationRequests": "Permintaan Reservasi Hotel",
      "request": "Permintaan",
      "backToListing": "Kembali ke Daftar",
      "confirmedReservationDetails": "Rincian Reservasi Terkonfirmasi",
      "reservationDetails": "Rincian Reservasi",
      "reservationNumber": "Nomor Reservasi",
      "invoiceNumber": "Nomor Faktur",
      "referenceNumber": "Nomor Referensi",
      "serialNumber": "Nomor Seri",
      "dueDate": "Jatuh Tempo",
      "billFrom": "TAGIHAN DARI",
      "billTo": "TAGIHAN KEPADA",
      "employeeName": "Nama Karyawan",
      "companyNumber": "Nomor Telepon",
      "employeeId": "ID Karyawan",
      "companyEmail": "Email Perusahaan",
      "entityCompany": "Entitas / Perusahaan",
      "companyTaxNumber": "Nomor Pajak / NPWP",
      "clientCompany": "Nama Tamu / Grup",
      "guestGroupName": "Nama Tamu / Grup",
      "guestGroupNameRequired": "Nama tamu / grup wajib diisi",
      "streetAddress": "Alamat Jalan",
      "cityCountry": "Kota / Negara",
      "accommodationsBreakdown": "Rincian Akomodasi",
      "hotelDetails": "Rincian Hotel",
      "numNight": "#Malam",
      "numRoom": "#Kamar",
      "adult": "Dewasa",
      "child": "Anak",
      "meals": "Makan",
      "dayRate": "Tarif Harian",
      "mealsRate": "Tarif Makan",
      "total": "Total",
      "subtotal": "Subtotal",
      "taxVat": "Pajak / PPN",
      "totalDue": "Total Tagihan",
      "remainingBalance": "Sisa Saldo Tagihan",
      "advancePayment": "Uang Muka (Deposit/DP)",
      "hasAdvancePayment": "Ada Uang Muka (DP)?",
      "advancePaymentAmount": "Jumlah Uang Muka",
      "exchangeRate": "KURS NILAI TUKAR",
      "totalDueIdr": "Total Tagihan (IDR)",
      "totalDueSar": "Total Tagihan (SAR)",
      "paymentInstructions": "Petunjuk Pembayaran",
      "bankName": "Nama Bank",
      "accountName": "Nama Rekening",
      "usdAccount": "Rekening USD",
      "idrAccount": "Rekening IDR",
      "printInvoice": "Cetak Faktur",
      "downloadPdf": "Unduh PDF",
      "viewPdf": "Lihat PDF",
      "approvalWorkflowStatus": "Status Alur Kerja Persetujuan",
      "madinahAccountant": "Akuntan Cabang Madinah",
      "confirmedAt": "Dikonfirmasi",
      "awaitingReviewYourLevel": "Menunggu Peninjauan (Tingkat Anda)",
      "awaitingReview": "Menunggu Peninjauan",
      "approvalsComplete": "1 dari 1 Persetujuan Selesai — Reservasi Dikonfirmasi",
      "approvalsPending": "0 dari 1 Persetujuan Selesai — Reservasi Menunggu",
      "readyForPayment": "Siap untuk pemrosesan pembayaran",
      "availableOperations": "Operasi Tersedia",
      "paymentSettled": "✓ Pembayaran Lunas Sepenuhnya (Ditutup)",
      "markAsPaid": "Tandai sebagai Lunas",
      "sendConfirmation": "Kirim Konfirmasi",
      "sendConfirmationRequest": "Kirim Permintaan Konfirmasi",
      "uploadPaymentInvoice": "Unggah Bukti Pembayaran / Faktur",
      "paymentProofRequired": "⚠️ Bukti pembayaran diperlukan",
      "paymentProofUploaded": "Bukti Pembayaran Terunggah",
      "readyToReview": "Siap untuk ditinjau",
      "viewProof": "Lihat Bukti",
      "changePaymentProof": "Ganti Bukti Pembayaran",
      "dragDropUpload": "Tarik & lepas atau klik untuk mengunggah",
      "uploadSupports": "Mendukung: PDF, JPG, PNG (maks 10MB)",
      "notes": "Catatan",
      "notesPlaceholder": "Tambahkan catatan pembayaran atau instruksi khusus...",
      "saveNote": "Simpan Catatan",
      "yourDecision": "Keputusan Anda",
      "decisionDesc": "Sebagai Akuntan Madinah, harap konfirmasikan verifikasi Permintaan Reservasi.",
      "rejectRequest": "Tolak Permintaan",
      "approve": "Setujui",
      "confirmApproval": "Konfirmasi Persetujuan",
      "confirmApprovalDesc": "Silakan masukkan nomor konfirmasi untuk melanjutkan persetujuan reservasi ini.",
      "confirmAndApprove": "Konfirmasi & Setujui",
      "approvedSuccessfully": "Berhasil Disetujui",
      "approvedSuccessfullyDesc": "Reservasi telah disetujui dan dikonfirmasi. Notifikasi telah dikirim ke pemohon.",
      "paymentTransferPhotoPdf": "Foto Transfer Pembayaran / PDF",
      "downloadImage": "Unduh Gambar",
      "addRoom": "Tambah Kamar",
      "createHotelReservation": "Buat Reservasi Hotel Baru",
      "stayType": "Tipe Menginap",
      "tentativeReservation": "Reservasi Tentatif",
      "confirmationReservation": "Reservasi Konfirmasi",
      "hotelName": "Nama Hotel",
      "hotelNamePlaceholder": "Masukkan Nama Hotel (contoh: SAFWAT AL MADINAH)",
      "checkInDate": "Tanggal Check-In",
      "checkOutDate": "Tanggal Check-Out",
      "nightsDuration": "#Malam (Durasi)",
      "adultsCount": "Jumlah Dewasa",
      "childrenCount": "Jumlah Anak",
      "mealPlan": "Paket Makan (Meal Plan)",
      "pricePerNight": "Tarif/Malam",
      "preview": "Pratinjau",
      "action": "Aksi",
      "createTentativeReservation": "Buat Reservasi Tentatif",
      "confNo": "No. Konfirmasi",
      "confirmReservation": "Konfirmasi Reservasi",
      "approvedByKarim": "Disetujui oleh Karim",
      "of": "dari",
      "billToClient": "TAGIHAN KEPADA (KLIEN)",
      "createNewHotelReservation": "Buat Reservasi Hotel Baru",
      "reservation": "Reservasi",
      "dayRatePricePerNight": "Tarif Harian (Harga / Malam)",
      "advancePaymentPlaceholder": "Masukkan nominal DP / Deposit...",
      "cifNumber": "Nomor CIF / Identitas Bank",
      "swiftCode": "Kode SWIFT",
      "bankBranchAddress": "Alamat Cabang Bank"
    },
  "settings": {
    "title": "Pengaturan Sistem",
    "subtitle": "Konfigurasi hak akses tim, kantor cabang operasional, notifikasi sistem, dan profil akun.",
    "profile": "Profil Pengguna",
    "team": "Manajemen Tim",
    "branches": "Kantor Cabang",
    "notifications": "Preferensi Notifikasi",
    "security": "Keamanan & Sandi",
    "exchangeRates": "Kurs Nilai Tukar",
    "dataBackup": "Pencadangan Data",
    "services": "Layanan",
    "companyInfo": "Informasi Perusahaan",
    "hbManagement": "Manajemen HB",
    "branchManagement": "Manajemen Kantor Cabang",
    "locationAddress": "Lokasi / Alamat",
    "branchName": "Nama Cabang",
    "addBranch": "Tambah Cabang",
    "addMember": "Tambah Anggota",
    "taxVatConfig": "Konfigurasi Pajak / PPN",
    "taxVatSubtitle": "Tetapkan persentase pajak atau PPN default yang diterapkan pada Konfirmasi",
    "taxNumber": "Nomor Pokok Wajib Pajak (NPWP / Tax No)",
    "taxInfo": "Informasi Pajak",
    "taxInfoSubtitle": "Atur nomor identifikasi pajak perusahaan untuk dokumen konfirmasi",
    "bankInfo": "Informasi Rekening Bank",
    "roomTypes": "Tipe Kamar",
    "mealPlans": "Paket Makan (Meal Plan)",
    "name": "Nama Lengkap",
    "email": "Alamat Email",
    "phone": "Nomor Telepon",
    "role": "Peran Akun",
    "password": "Kata Sandi",
    "newPassword": "Kata Sandi Baru",
    "confirmPassword": "Ulangi Kata Sandi Baru",
    "downloadBackup": "Unduh Cadangan Lengkap (.json)",
    "exportCsvData": "Ekspor Data CSV",
    "personalDetails": "Rincian Pribadi",
    "profileDisplayPicture": "Foto Profil Akun",
    "photoGuidelines": "Format PNG, JPG atau GIF hingga 5MB. Rekomendasi 400×400px.",
    "changePhoto": "Ganti Foto",
    "companyAssignment": "Penempatan Perusahaan (Hanya Baca)",
    "readOnly": "Hanya Baca",
    "registeredCompany": "Perusahaan Terdaftar",
    "defaultBranch": "Kantor Cabang Utama",
    "employeeId": "ID Karyawan",
    "department": "Departemen",
    "jobTitle": "Jabatan",
    "currentPassword": "Kata Sandi Saat Ini",
    "enterNewPassword": "Masukkan kata sandi baru",
    "reenterNewPassword": "Ulangi kata sandi baru",
    "updatePassword": "Perbarui Kata Sandi",
    "activeSessions": "Sesi Operator Aktif",
    "loginActivityLogs": "Log Aktivitas Masuk (5 upaya terakhir)",
    "timestamp": "Waktu",
    "ipAddress": "Alamat IP",
    "operatingAgent": "Agen / Perangkat",
    "revoke": "Cabut",
    "current": "Saat Ini",
    "confirmationNotifications": "Notifikasi Konfirmasi Keuangan",
    "approvalNotifications": "Notifikasi Alur Persetujuan",
    "systemNotifications": "Notifikasi Sistem & Keamanan",
    "alertType": "Tipe Notifikasi",
    "emailChannel": "Email",
    "inAppChannel": "Dalam Aplikasi",
    "notifNewInvoiceTitle": "Konfirmasi baru diajukan",
    "notifNewInvoiceDesc": "Pemberitahuan saat tim cabang mengajukan konfirmasi baru.",
    "notifApprovedTitle": "Konfirmasi disetujui",
    "notifApprovedDesc": "Pemberitahuan saat konfirmasi telah lolos verifikasi akhir dan disetujui.",
    "notifRejectedTitle": "Konfirmasi ditolak",
    "notifRejectedDesc": "Pemberitahuan jika konfirmasi ditolak atau dikembalikan untuk revisi.",
    "notifPaymentTitle": "Pembayaran diterima",
    "notifPaymentDesc": "Pemberitahuan saat transaksi pembayaran berhasil dicatat.",
    "notifAssignedTitle": "Permintaan persetujuan ditugaskan",
    "notifAssignedDesc": "Terima pemberitahuan saat ada antrean persetujuan baru untuk Anda.",
    "notifApprovalDoneTitle": "Persetujuan selesai",
    "notifApprovalDoneDesc": "Pemberitahuan saat tim hilir memproses antrean yang telah disetujui.",
    "notifApprovalOverdueTitle": "Persetujuan jatuh tempo",
    "notifApprovalOverdueDesc": "Pemberitahuan penting jika antrean persetujuan melewati batas waktu.",
    "notifSecurityTitle": "Peringatan keamanan",
    "notifSecurityDesc": "Dapatkan pemberitahuan tentang upaya masuk dari alamat IP yang tidak dikenal.",
    "notifTeamChangesTitle": "Perubahan anggota tim",
    "notifTeamChangesDesc": "Pemberitahuan saat super admin menambah atau menghapus operator platform.",
    "notifMaintenanceTitle": "Pemeliharaan sistem",
    "notifMaintenanceDesc": "Dapatkan pemberitahuan sebelum jadwal pembaruan sistem dan offline.",
    "dailyExchangeRate": "Kurs Nilai Tukar Harian",
    "exchangeRateSubtitle": "Perbarui kurs mata uang harian secara manual untuk perhitungan konfirmasi",
    "todayExchangeRate": "Kurs Nilai Tukar Hari Ini",
    "rateHistory": "Riwayat Perubahan Kurs",
    "updated": "Diperbarui",
    "saveRates": "Simpan Nilai Kurs",
    "backupInfrastructure": "Cadangan Data Sistem & Ekspor Infrastruktur",
    "backupSubtitle": "Buat dan unduh cadangan snapshot basis data lengkap untuk pemulihan bencana offline.",
    "downloadFullBackup": "Unduh Cadangan Penuh (.json)",
    "fullBackupSubtitle": "Mencakup Faktur, Reservasi, Klien, dan Pengaturan",
    "generatingBackup": "Sedang Menyiapkan Cadangan...",
    "autoCloudBackup": "Cadangan Otomatis Cloud",
    "activeSnapshot": "Aktif (Auto Snapshot)",
    "serverDeployments": "Penyebaran Server",
    "synchronizedGit": "Tersinkronisasi (Git Main)",
    "members": "Anggota",
    "addNewMember": "Tambah Anggota Tim Baru",
    "editMember": "Ubah Anggota Tim",
    "deleteMember": "Hapus Anggota Tim",
    "confirmDeletion": "Konfirmasi Penghapusan",
    "confirmDeletionDesc": "Apakah Anda yakin ingin menghapus {{name}} ({{email}}) dari tim?",
    "deleteWarning": "Peringatan: Tindakan ini tidak dapat dibatalkan. Pengguna ini akan langsung kehilangan semua akses ke sistem.",
    "yesRemove": "Ya, Hapus",
    "confirmAction": "Konfirmasi Tindakan",
    "confirmAddMember": "Apakah Anda yakin ingin menambahkan anggota ini?",
    "confirmAddMemberDesc": "Tindakan ini akan mengirimkan email undangan kepada anggota tim baru agar mereka dapat mengakses platform.",
    "yesAddMember": "Ya, Tambah Anggota",
    "memberAddedSuccess": "Anggota Berhasil Ditambahkan!",
    "memberAddedSuccessDesc": "Anggota tim baru telah ditambahkan dan email undangan telah dikirimkan.",
    "errorsFound": "{{count}} kesalahan ditemukan. Harap perbaiki sebelum mengirimkan.",
    "fullNameRequired": "Nama Lengkap wajib diisi",
    "emailRequired": "Alamat Email wajib diisi",
    "branchRequired": "Kantor cabang wajib diisi. Tambahkan di pengaturan terlebih dahulu.",
    "autoGeneratedEmpId": "Dibuat otomatis jika dikosongkan",
    "assignedBranch": "Penugasan Kantor Cabang",
    "rolesMatrix": "Matriks Peran & Izin",
    "rolesMatrixSubtitle": "Ringkasan izin default di seluruh peran sistem",
    "permission": "Izin",
    "createConfirmations": "Buat Konfirmasi",
    "approveConfirmations": "Setujui Konfirmasi",
    "manageCompanies": "Kelola Perusahaan",
    "viewReports": "Lihat Laporan",
    "manageTeam": "Kelola Tim",
    "branchStats": "Statistik Kantor Cabang",
    "totalBranches": "Total Cabang",
    "activeBranches": "Cabang Aktif",
    "totalStaffAcrossBranches": "Total Staf di Semua Cabang",
    "createBranch": "Buat Kantor Cabang Baru",
    "createBranchSubtitle": "Kantor cabang menyimpan seluruh riwayat transaksi operasional Anda.",
    "companyIdentity": "Identitas Perusahaan",
    "companyIdentitySubtitle": "Perbarui nama perusahaan atau entitas Anda yang ditampilkan pada konfirmasi",
    "contactInfo": "Informasi Kontak",
    "contactInfoSubtitle": "Perbarui nomor telepon dan detail kontak perusahaan Anda",
    "defaultNotes": "Catatan Default",
    "defaultNotesSubtitle": "Teks catatan standar yang tercantum di bagian bawah dokumen konfirmasi",
    "termsAndConditions": "Syarat & Ketentuan",
    "termsAndConditionsSubtitle": "Ketentuan pembayaran standar yang tercantum pada konfirmasi",
    "bankAccountSubtitle": "Tambahkan detail rekening bank perusahaan Anda untuk konfirmasi",
    "bankName": "Nama Bank",
    "accountHolderName": "Nama Pemilik Rekening",
    "idrAccountNumber": "Nomor Rekening IDR",
    "usdAccountNumber": "Nomor Rekening USD",
    "bankBranchAddress": "Alamat Cabang Bank",
    "cifNumber": "Nomor CIF / Identitas Bank",
    "swiftCode": "Kode SWIFT",
    "bankBranchAddressPlaceholder": "Masukkan alamat cabang bank",
    "cifNumberPlaceholder": "Masukkan nomor CIF / Identitas bank",
    "swiftCodePlaceholder": "Masukkan kode SWIFT (contoh: BDINIDJA)",
    "roomTypeSubtitle": "Kelola daftar tipe kamar hotel standar yang tersedia di sistem",
    "mealPlanSubtitle": "Kelola daftar paket makan (meal plan) hotel yang tersedia di sistem",
    "addRoomType": "Tambah Tipe Kamar",
    "addMealPlan": "Tambah Paket Makan",
    "roomTypeName": "Nama Tipe Kamar",
    "mealPlanName": "Nama Paket Makan",
    "mealPlanCode": "Kode Paket Makan",
    "exportHistory": "Riwayat Ekspor",
    "exportType": "Tipe Ekspor",
    "filename": "Nama File",
    "exportedBy": "Diekspor Oleh",
    "fullBackupDesc": "Mengekspor payload JSON lengkap yang berisi seluruh catatan buku besar aktif, reservasi hotel, data direktori klien, dan parameter kurs nilai tukar untuk arsip offline.",
    "noExportThisSession": "Belum ada ekspor pada sesi ini",
    "lastExport": "Ekspor terakhir: {{time}}",
    "hostingInfrastructure": "Infrastruktur Hosting & Cadangan Basis Data",
    "productionDbDeployment": "Penyebaran Basis Data Produksi & Server Web",
    "authorizedControllers": "Pengendali IT Berwenang",
    "cloudBackupNote": "* Cadangan cloud otomatis berjalan secara berkelanjutan pada server basis data produksi aktif Anda.",
    "adminItOnly": "Khusus Admin Sistem & IT",
    "accessRestricted": "Akses Dibatasi",
    "backupAccessRestrictedDesc": "Bagian pencadangan sistem ini dibatasi secara ketat. Hanya Administrator IT (Dimas & Ali) yang berwenang untuk mengakses dan mengunduh cadangan lengkap basis data.",
    "exportCsvDesc": "Unduh dataset terpisah yang kompatibel dengan Microsoft Excel & Google Sheets",
    "exportInvoicesDesc": "Semua entri konfirmasi keuangan",
    "exportReservationsDesc": "Data reservasi & kamar hotel",
    "exportCompaniesDesc": "Data perusahaan & mitra",
    "exportHistoryDesc": "Log riwayat ekspor data. Jika file hilang, klik \"Unduh Ulang\" untuk mengekstrak salinan cadangan baru.",
    "redownload": "Unduh Ulang",
    "redownloadDesc": "Unduh ulang salinan cadangan ini",
    "noExportHistory": "Belum ada riwayat ekspor. Menghasilkan cadangan akan mencatat entri di sini secara otomatis.",
    "loadingExportHistory": "Memuat log riwayat...",
    "maintenanceBroadcastTitle": "Siaran Pemeliharaan Sistem",
    "maintenanceBroadcastDesc": "Kirim jadwal pemeliharaan, upgrade, atau perbaikan modul ke seluruh pengguna secara instan.",
    "scopeLabel": "Target Cakupan Pemeliharaan",
    "scopeAll": "Seluruh Sistem (Full System)",
    "scopeReservations": "Modul Reservasi Hotel",
    "scopeInvoices": "Modul Faktur & Pembayaran",
    "scopeApprovals": "Modul Alur Persetujuan",
    "scopeSettings": "Modul Pengaturan & Database",
    "scheduleTimeLabel": "Jadwal Pemeliharaan (Tanggal & Jam)",
    "scheduleTimePlaceholder": "Contoh: Hari ini pukul 23:00 - 23:30 WIB",
    "urgencyLabel": "Tingkat Urgensi",
    "urgencyNormal": "Normal (Informasi Rutin)",
    "urgencyHigh": "Tinggi (Potensi Downtime / Gangguan)",
    "messageLabel": "Pesan Pengumuman Pemeliharaan",
    "messagePlaceholder": "Jelaskan perbaikan, upgrade, atau instruksi bagi pengguna saat pemeliharaan berlangsung...",
    "quickTemplates": "Template Cepat",
    "tplServerUpgrade": "Upgrade Server & Performa",
    "tplHotelModule": "Pemeliharaan Modul Reservasi",
    "tplDatabaseSync": "Optimalisasi & Sinkronisasi DB",
    "livePreview": "Pratinjau Notifikasi Pengguna",
    "sendBroadcastBtn": "Kirim Siaran Sekarang",
    "sendingBroadcast": "Mengirim Siaran...",
    "confirmBroadcastTitle": "Konfirmasi Kirim Siaran Pemeliharaan",
    "confirmBroadcastMsg": "Apakah Anda yakin ingin menyiarkan pemberitahuan pemeliharaan ini ke seluruh akun pengguna? Notifikasi In-App dan Email akan langsung terdistribusi.",
    "broadcastSuccess": "Siaran jadwal pemeliharaan berhasil dikirimkan ke seluruh pengguna!",
    "maintenanceLocksTitle": "Status & Saklar Kunci Pemeliharaan Modul",
    "maintenanceLocksDesc": "Kunci akses pengguna biasa saat perbaikan berlangsung. Tim IT (Dimas & Ali) tetap memiliki akses penuh (Bypass).",
    "bypassActive": "Bypass IT: Aktif (Dimas & Ali)",
    "itBypassHeader": "Kunci Pemeliharaan Aktif (Akses Khusus IT Bypass)",
    "lockModuleBtn": "Kunci Modul Ini",
    "unlockModuleBtn": "Buka Kunci Modul",
    "lockSystemBtn": "Kunci Seluruh Sistem",
    "unlockSystemBtn": "Buka Kunci Sistem",
    "statusLocked": "Terkunci",
    "statusActive": "Aktif",
    "statusEmergencyLocked": "DARURAT TERKUNCI",
    "pageClosedForUsers": "Halaman ditutup untuk pengguna umum.",
    "pageNormalForUsers": "Dapat diakses normal oleh semua pengguna.",
    "systemClosedForUsers": "Semua modul terkunci kecuali Login & Settings IT.",
    "systemNormalForUsers": "Seluruh sistem beroperasi normal.",
    "autoLockOnBroadcast": "Sekaligus kunci akses modul yang dipilih saat siaran dikirim",
    "maintenanceScreen": {
      "badge": "Mode Pemeliharaan Aktif",
      "closedTitle": "{{module}} Sedang Ditutup Sementara",
      "subtitle": "Halaman ini sedang mengalami proses pemeliharaan atau peningkatan infrastruktur oleh Tim IT.",
      "scheduleLabel": "Estimasi / Jadwal:",
      "detailsLabel": "Keterangan:",
      "defaultMsg": "Proses pembaruan sistem berkala sedang berlangsung untuk menjaga kestabilan data.",
      "notice": "Akses formulir dan pengolahan data pada modul ini dinonaktifkan sementara untuk mencegah korupsi data. Silakan hubungi Administrator IT (Ali / Dimas) jika memerlukan bantuan operasional mendesak.",
      "backDashboard": "Kembali ke Dashboard Utama",
      "openInvoices": "Buka Modul Confirmations (Faktur)"
    }
  },
  "auth": {
    "welcome": "Selamat Datang",
    "welcomeBack": "Selamat Datang Kembali",
    "signInDesc": "Masuk ke akun Anda untuk melanjutkan ke sistem keuangan",
    "emailOrPhone": "Email atau Nomor Telepon",
    "enterPassword": "Masukkan kata sandi Anda",
    "rememberMe": "Ingat saya di perangkat ini",
    "forgotPassword": "Lupa kata sandi?",
    "signIn": "Masuk",
    "signingIn": "Sedang masuk...",
    "resetPasswordTitle": "Atur ulang kata sandi Anda",
    "resetPasswordDesc": "Masukkan alamat email Anda dan kami akan mengirimkan tautan reset.",
    "emailAddress": "Alamat Email",
    "enterEmail": "Masukkan email Anda",
    "sendResetLink": "Kirim Tautan Reset",
    "sending": "Mengirim...",
    "backToSignIn": "Kembali ke Masuk",
    "checkYourEmail": "Periksa email Anda",
    "resetLinkSent": "Kami telah mengirimkan tautan reset kata sandi ke {{email}}. Tautan ini akan kedaluwarsa dalam 30 menit.",
    "didntReceiveEmail": "Tidak menerima email?",
    "resend": "Kirim Ulang",
    "resending": "Mengirim ulang...",
    "createNewPassword": "Buat kata sandi baru",
    "enterNewPasswordDesc": "Silakan masukkan kata sandi baru Anda di bawah ini.",
    "newPassword": "Kata Sandi Baru",
    "enterNewPassword": "Masukkan kata sandi baru",
    "confirmPassword": "Konfirmasi Kata Sandi",
    "confirmNewPassword": "Konfirmasi kata sandi baru",
    "resetPassword": "Atur Ulang Kata Sandi",
    "resetting": "Mengatur ulang...",
    "resetCompleteTitle": "Reset Kata Sandi Selesai",
    "resetCompleteDesc": "Kata sandi Anda telah berhasil diatur ulang. Anda sekarang dapat menggunakan kata sandi baru untuk masuk.",
    "emailOrPhoneRequired": "Email atau nomor telepon wajib diisi",
    "validEmailRequired": "Silakan masukkan alamat email yang valid",
    "passwordRequired": "Kata sandi wajib diisi",
    "passwordMinLength": "Kata sandi minimal harus 6 karakter",
    "passwordsDoNotMatch": "Konfirmasi kata sandi tidak cocok",
    "enterEmailRequired": "Silakan masukkan alamat email Anda",
    "tokenMissing": "Token reset kata sandi tidak ditemukan. Silakan minta tautan baru.",
    "invalidCredentials": "Kredensial tidak valid. Silakan coba lagi.",
    "failedToSendResetLink": "Gagal mengirim tautan reset. Silakan coba lagi.",
    "failedToResetPassword": "Gagal mengatur ulang kata sandi. Token mungkin tidak valid atau sudah kedaluwarsa."
  },
  "expenses": {
    "title": "Pengeluaran Saya",
    "subtitle": "Pantau, ajukan, dan kelola semua status klaim pengeluaran & reimbursement perusahaan Anda.",
    "submitNewClaim": "Ajukan Klaim Baru",
    "exportExcel": "Ekspor Excel",
    "totalClaims": "Total Pengajuan",
    "pendingApproval": "Menunggu Persetujuan",
    "approvedPayout": "Disetujui / Siap Cair",
    "settledPaid": "Tuntas & Dibayarkan",
    "allClaims": "Semua Klaim",
    "pending": "Menunggu",
    "approved": "Disetujui",
    "paid": "Dibayar",
    "rejected": "Ditolak",
    "searchPlaceholder": "Cari ID klaim, kategori, atau catatan...",
    "claimId": "ID Klaim",
    "date": "Tanggal",
    "category": "Kategori",
    "amount": "Nominal",
    "bank": "Rekening Tujuan",
    "approvalChain": "Alur Persetujuan",
    "status": "Status",
    "receipt": "Bukti Nota",
    "actions": "Aksi",
    "viewDetail": "Lihat Detail",
    "viewTransferProof": "Bukti Transfer",
    "viewApprovalDetail": "Alur Persetujuan",
    "claimDetails": "Detail Klaim & Bukti Nota",
    "receiptPreview": "Pratinjau Dokumen Nota",
    "noReceipts": "Tidak ada bukti terlampir"
  },
  "submitExpense": {
    "title": "Ajukan Pengeluaran Korporat",
    "subtitle": "Unggah bukti nota, faktur, dan kwitansi yang sah untuk peninjauan departemen dan audit keuangan.",
    "dropzoneTitle": "Tarik & lepas file nota di sini atau klik untuk memilih",
    "dropzoneHint": "Format yang didukung: PDF, JPG, PNG, WEBP (Maks 15MB per file). Mendukung banyak file sekaligus.",
    "category": "Kategori Pengeluaran",
    "selectCategory": "Pilih kategori...",
    "expenseDate": "Tanggal Pengeluaran",
    "amount": "Nominal Pengeluaran",
    "currency": "Mata Uang",
    "merchant": "Nama Merchant / Vendor",
    "taxVatId": "NPWP / VAT ID (Opsional)",
    "purpose": "Keperluan / Deskripsi Bisnis",
    "bankDestination": "Rekening Bank Tujuan",
    "selectBank": "Pilih rekening bank karyawan...",
    "submitClaim": "Kirim Pengajuan Klaim",
    "submitting": "Mengirimkan Klaim...",
    "successTitle": "Klaim Pengeluaran Berhasil Diajukan!",
    "successDesc": "Klaim Anda telah terdaftar dengan referensi {{id}} dan diteruskan ke manajer langsung untuk ditinjau.",
    "trackClaim": "Pantau di Pengeluaran Saya"
  },
  "approvals": {
    "title": "Dashboard Persetujuan Keuangan",
    "subtitle": "Audit klaim yang telah disetujui, siapkan pencairan bank, ekspor daftar tervalidasi ke ERP, atau selesaikan massal via API Bank.",
    "pendingFinance": "Menunggu Audit Finance",
    "readyDisburse": "Siap Dicairkan",
    "totalValue": "Total Nilai Klaim",
    "processedMonth": "Diproses Bulan Ini",
    "addToPayroll": "Gabung ke Payroll",
    "delete": "Hapus",
    "deleteConfirmTitle": "Hapus Klaim yang Dipilih",
    "deleteConfirmDesc": "Apakah Anda yakin ingin menghapus {{count}} klaim yang dipilih? Tindakan ini tidak dapat dibatalkan.",
    "deleteWarning": "Tindakan ini akan menghapus data klaim terpilih secara permanen dari antrean pembayaran.",
    "exportAndSchedule": "Ekspor Excel & Konfirmasi",
    "transferToBank": "Transfer ke Bank",
    "selectAll": "Pilih Semua",
    "batchAction": "Aksi Massal",
    "employee": "Karyawan",
    "department": "Departemen",
    "reviewAudit": "Tinjau & Audit Klaim",
    "payrollSuccess": "Berhasil Ditambahkan ke Siklus Payroll",
    "bankSuccess": "Transfer Berhasil Diinisiasi"
  },
  "expenseApproval": {
    "title": "Audit & Persetujuan Klaim",
    "subtitle": "Tinjau dan proses klaim reimbursement yang tertunda serta audit dokumen bukti nota.",
    "claimProfile": "Profil Klaim",
    "workflowStepper": "Tahapan Alur Persetujuan",
    "workflowSubtitle": "Rantai Otorisasi Eksekutif 3 Tingkat",
    "receiptView": "Dokumen Nota Digital",
    "vatSummary": "Rincian Pajak & PPN",
    "transferAmount": "Transfer Nominal",
    "rejectClaim": "Tolak Klaim",
    "requestClarification": "Minta Klarifikasi",
    "approveClaim": "Setujui Klaim",
    "itMode": "Mode Akses & Pengujian IT",
    "resetSimulation": "Reset Simulasi",
    "approverSimulation": "Simulasi Wewenang Approver:",
    "flowShortcuts": "Pintas Alur Halaman:",
    "initiateReimbursementShortcut": "Inisiasi Reimbursement",
    "preExecutionPaymentShortcut": "Pre-Execution Payment",
    "employeeBankDataShortcut": "Data Rekening Karyawan",
    "fullItBypass": "Full IT Bypass",
    "disbursedCompleteTitle": "Pembayaran Selesai & Lunas",
    "disbursedCompleteDesc": "Dana telah berhasil ditransfer ke rekening {{name}} ({{bank}} - {{account}}).",
    "viewTransferProofAndAudit": "Lihat Bukti Transfer & Sertifikat Audit",
    "accessDeniedApprover": "Akses Ditolak: Bukan Approver Resmi",
    "accessDeniedDesc": "Hanya 3 pejabat yang berwenang menyetujui (Mr. Hesham Mokhtar, Mr. Khalid Idriss, dan Mr. Emad Moustafa). Akun Super Admin dan staf lainnya tidak memiliki hak persetujuan.",
    "notYourTurn": "Bukan Giliran Persetujuan Anda",
    "notYourTurnDesc": "Anda terotentikasi sebagai {{name}}. Namun persetujuan Tahap {{step}} saat ini merupakan wewenang eksklusif {{approver}} ({{role}}).",
    "yourTurn": "Giliran Anda: {{name}}",
    "yourTurnDesc": "Wewenang persetujuan Tahap {{step}} ({{role}}) aktif.",
    "approveStage": "Setujui Tahap {{step}} ({{name}})",
    "fullyApprovedWaitingDisbursement": "Klaim Telah Disetujui Penuh (3/3 Selesai)",
    "fullyApprovedHoldNotice": "Persetujuan Eksekutif 3 Tingkat Telah Selesai. Proses pencairan otomatis via bank ditahan sementara menunggu integrasi API Bank BNI.",
    "approvalDisabledWaiting": "Menunggu Persetujuan Tahap {{step}} ({{approver}})",
    "approvalDisabledNoAuth": "Persetujuan Dinonaktifkan (Memerlukan Akun Approver)",
    "claimClosedNotes": "Klaim ini telah disetujui dan dicatat dalam sistem keuangan.",
    "noApprovalNotesPermitted": "Anda tidak dapat memberikan catatan persetujuan pada tahap ini.",
    "approvalNotesPlaceholder": "Tambahkan catatan persetujuan atau instruksi jika memerlukan klarifikasi...",
    "executionStatusLabel": "Status Eksekusi",
    "executionStatusValue": "Persetujuan Eksekutif 3/3 Selesai",
    "cryptoValidationLabel": "Validasi Kriptografi",
    "cryptoValidationValue": "SHA-256 Verified Immutable",
    "claimArchivedLog": "Klaim telah selesai diproses & tercatat di audit log.",
    "statusTransferred": "Status: Lunas & Terkirim (Paid & Disbursed)",
    "statusTransferredDesc": "Klaim ini telah berhasil dieksekusi melalui transaksi Host-to-Host perbankan dan dana telah dikreditkan ke rekening {{name}}.",
    "authorized": "Otorisasi Aktif",
    "stageApprovedTitle": "Tahap {{step}} Disetujui!",
    "fullyApprovedMsg": "Klaim reimbursement {{claimId}} telah disetujui penuh (3/3) oleh Mr. Emad Moustafa.",
    "stepApprovedMsg": "Persetujuan Tahap {{step}} ({{name}}) berhasil disimpan. Klaim dialihkan ke tahap berikutnya.",
    "accessDeniedTitle": "Akses Ditolak",
    "accessDeniedRejectMsg": "Anda tidak berwenang menolak klaim pada tahap ini.",
    "accessDeniedClarifyMsg": "Anda tidak berwenang meminta klarifikasi pada tahap ini.",
    "accessDeniedDisburseMsg": "Hanya Mr. Emad Moustafa (Financial Controller / Treasury) yang dapat menginisiasi pencairan bank.",
    "claimRejectedTitle": "Klaim Ditolak",
    "claimRejectedMsg": "Klaim reimbursement {{claimId}} telah ditolak.",
    "clarificationRequestedTitle": "Klarifikasi Diminta",
    "clarificationRequestedMsg": "Notifikasi telah dikirim ke {{name}} untuk meminta rincian tambahan.",
    "fullSettled": "LUNAS TUNTAS"
  },
  "initiateReimbursement": {
    "title": "Inisiasi Pencairan Bank",
    "subtitle": "Tinjau ringkasan klaim, pilih rekening debit pendanaan perusahaan, dan picu pembayaran otomatis via API Host-to-Host.",
    "claimSummary": "Ringkasan Klaim Disetujui",
    "fundingSource": "Sumber Dana Korporat",
    "beneficiaryDetails": "Detail Rekening Penerima",
    "attentionController": "PERHATIAN CONTROLLER",
    "attentionDesc": "Dengan mengklik Inisiasi Pembayaran di bawah, Anda mengotorisasi pencairan langsung dana ke rekening bank karyawan yang telah terverifikasi di atas.",
    "initiatePayment": "Inisiasi Pembayaran",
    "cancelExecution": "Batalkan Eksekusi",
    "verifiedAccount": "Rekening Terverifikasi",
    "transferToBank": "Transfer ke Bank",
    "apiIntegrated": "Aktif • Terintegrasi API",
    "apiInactive": "Nonaktif • API Belum Terhubung",
    "transferDesc": "Inisiasi settlement transfer lokal instan melalui jalur otomatis Host-to-Host (SNAP BI).",
    "gatewayCallout": "Terhubung langsung ke {{bank}} API Gateway (SNAP BI TLS 1.3). Saldo rekening korporasi terverifikasi.",
    "gatewayInactiveCallout": "Gateway {{bank}} saat ini sedang nonaktif atau belum terkonfigurasi. Hubungi Tim IT Super Admin untuk mengaktifkannya.",
    "gatewayInactiveWarning": "Jalur transfer otomatis bank sedang ditangguhkan karena status gateway nonaktif.",
    "disbursedAlertTitle": "STATUS: DANA TELAH DITRANSFER & LUNAS",
    "disbursedAlertDesc": "Transaksi pembayaran untuk klaim ini telah berhasil diproses ke rekening penerima di atas. Pembayaran ganda dinonaktifkan demi keamanan.",
    "viewTransferProofAndAudit": "Lihat Bukti Transfer & Audit"
  },
  "setupBeneficiary": {
    "title": "Atur Rekening Penerima",
    "subtitle": "Konfigurasi dan verifikasi rekening bank karyawan untuk pencairan otomatis via API Host-to-Host (SNAP BI).",
    "clearingDomestic": "Jalur Kliring Domestik Bank Indonesia (SNAP BI / BI-FAST TLS 1.3)",
    "clearingInternational": "Jalur Kliring Internasional & Saudi Arabian Real-Time Express (SARIE)",
    "bankName": "Nama Bank",
    "targetCurrency": "Mata Uang Tujuan",
    "accountHolder": "Nama Pemilik Rekening",
    "accountHolderNote": "Nama harus sesuai dengan yang terdaftar resmi pada identitas KTP/Buku Tabungan.",
    "accountNumber": "Nomor Rekening",
    "accountNumberPlaceholder": "Nomor Rekening {{bank}} ({{min}}-{{max}} Digit)",
    "checkAccount": "Cek & Inkuiri Rekening",
    "checkingAccount": "Memeriksa ke Bank...",
    "accountVerifiedOfficial": "Terverifikasi Resmi via {{network}}",
    "accountNameMatched": "Nama Terdaftar di Bank: {{name}}",
    "accountStatusActive": "Status Rekening: AKTIF",
    "accountNotFound": "Nomor rekening {{account}} TIDAK DITEMUKAN atau TIDAK AKTIF pada server {{bank}} (Kode Respon SNAP BI: 404 ACCOUNT_NOT_FOUND). Silakan masukkan nomor rekening asli yang valid.",
    "accountInquiryFailed": "Gagal menghubungi gateway inkuiri perbankan.",
    "formatValid": "Format Nomor Rekening Valid ({{min}}-{{max}} Digit)",
    "iban": "IBAN (24 Karakter)",
    "ibanOptional": "IBAN (Tidak Wajib untuk Transfer Domestik Indonesia)",
    "ibanOptionalPlaceholder": "Tidak diperlukan untuk transfer perbankan lokal Indonesia (Opsional)",
    "ibanRequired": "IBAN Wajib 24 Karakter (Format Arab Saudi)",
    "ibanValid": "IBAN 24 Karakter Valid",
    "ibanInvalid": "IBAN harus tepat 24 karakter (dimulai dengan SA)",
    "swift": "Kode SWIFT / BIC",
    "branchLocation": "Kantor Cabang Bank",
    "saveAccount": "Simpan & Verifikasi Rekening",
    "accountVerified": "Rekening Penerima Berhasil Diverifikasi!",
    "modalVerifiedDesc": "Kredensial rekening bank untuk {{name}} di {{bank}} telah diverifikasi dan disimpan untuk pencairan penggantian instan.",
    "proceedToReimbursement": "Lanjutkan ke Pencairan Dana"
  },
  "preExecutionPayment": {
    "reviewTitle": "Tinjauan Pembayaran Pra-Eksekusi",
    "reviewSubtitle": "Lakukan otorisasi faktor ganda (2FA). Pastikan jejak audit mematuhi batas tata kelola perusahaan standar.",
    "tunnelTitle": "Terowongan Settlement API",
    "tunnelSubtitle": "Handshake koneksi Host-to-Host langsung ke API Bank.",
    "dispatchedTitle": "Pembayaran Berhasil Dikirim",
    "dispatchedSubtitle": "Dana berhasil dirutekan dan diakui oleh gateway. Berkas audit telah dikompilasi.",
    "confirmAuthorize": "Konfirmasi & Otorisasi Transfer",
    "enterOtp": "Masukkan Kode OTP 2FA",
    "otpPlaceholder": "6-digit OTP",
    "settlePaid": "LUNAS TUNTAS",
    "downloadVoucher": "Unduh Bukti PDF",
    "auditTrail": "Jejak Audit Kepatuhan & Eksekusi",
    "exportCertificate": "Ekspor Sertifikat Audit Lengkap",
    "copyHash": "Salin Master Hash Audit",
    "hashCopied": "Hash Tersalin!",
    "inspect": "Inspeksi",
    "stepOf": "Langkah {{current}} dari {{total}}",
    "verifiedImmutable": "Terverifikasi & Imutabel",
    "authorizedSigner": "Penandatangan Sah / Gateway",
    "authProof": "Bukti Autentikasi",
    "telemetry": "Telemetri Audit & Jejak Jaringan",
    "digitalSignature": "Tanda Tangan Digital SHA-256",
    "governancePolicy": "Kepatuhan Tata Kelola & Kebijakan",
    "signerRemarks": "Catatan Penandatangan & Eksekusi",
    "closeInspector": "Tutup Inspektor",
    "nextStep": "Langkah Berikutnya",
    "prevStep": "Langkah Sebelumnya",
    "realtimeLifecycle": "SIKLUS HIDUP PENGIRIMAN API REALTIME",
    "apiHandshake": "Handshake API",
    "balanceVerified": "Saldo Terverifikasi",
    "dispatching": "Mengirimkan",
    "traceIdLabel": "Trace ID Transaksi",
    "settlementEndpoint": "Endpoint Settlement",
    "estimatedCompletion": "Estimasi Waktu Penyelesaian",
    "under30Sec": "< 30 detik",
    "autoRefreshWarning": "Panel ini memperbarui secara otomatis. Jangan muat ulang atau keluar dari halaman.",
    "otpSentTo": "OTP telah dikirim ke nomor ponsel {{chiefAccountant}} ({{chiefAccountantRole}}) & {{controller}} ({{controllerRole}}).",
    "resendCodeSec": "Kirim ulang kode ({{sec}}d)",
    "resendCodeNow": "Kirim ulang kode sekarang",
    "verifyInvoiceCheckbox": "Saya memverifikasi bahwa rincian transaksi di atas telah diverifikasi dan siap ditransfer sebesar {{amount}}.",
    "debitAccountSender": "REKENING DEBIT (PENGIRIM)",
    "creditAccountRecipient": "REKENING KREDIT (PENERIMA)",
    "settlementRoute": "Jalur Settlement",
    "estimatedSpeed": "Estimasi Kecepatan",
    "backToClaim": "Kembali ke Klaim",
    "stepMsg1": "Menginisiasi transaksi pembayaran untuk klaim {{claim}}...",
    "stepMsg2": "Melakukan handshake mTLS 1.3 dengan gateway {{bank}}...",
    "stepMsg3": "Memverifikasi otorisasi saldo & limit rekening perusahaan...",
    "stepMsg4": "Mentransfer dana Host-to-Host langsung ke {{employee}} ({{bank}})...",
    "stepMsg5": "Transfer berhasil diselesaikan! Menyiapkan bukti disbursement..."
  },
  "superAdmin": {
    "badge": "Super Admin",
    "title": "Dashboard Super Admin",
    "subtitle": "Kelola izin pengguna, pantau log audit, dan kelola cadangan sistem.",
    "refreshData": "Perbarui Data",
    "restrictedTitle": "Akses Dibatasi",
    "restrictedDesc": "Dashboard Super Admin Mini khusus untuk Administrator Sistem (Dimas & Ali). Akun Anda saat ini tidak memiliki izin untuk mengakses panel ini.",
    "returnToDashboard": "Kembali ke Dashboard",
    "tabs": {
      "permissionMatrix": "Matriks Izin",
      "users": "Pengguna",
      "auditLogs": "Log Audit Sistem",
      "dataBackup": "Pencadangan Data",
      "systemMaintenance": "Pemeliharaan Sistem",
      "bankingApi": "Jalur API & Perbankan"
    },
    "bankingApi": {
      "metrics": {
        "snapBiTitle": "SNAP BI",
        "snapBiDesc": "Standar Open API Bank Indonesia",
        "tlsTitle": "TLS 1.3 Wajib",
        "tlsDesc": "PADG BI No. 23/15/PADG/2021",
        "latencyDesc": "Latensi BNI H2H",
        "shaTitle": "SHA-256 / RSA",
        "shaDesc": "Tanda Tangan Digital Asimetris"
      },
      "form": {
        "title": "Pengaturan Parameter: {{name}}",
        "subtitle": "Konfigurasi kredensial Host-to-Host, Base URL, dan Webhook untuk integrasi langsung.",
        "testPing": "Uji Koneksi (Ping)",
        "testing": "Menguji...",
        "gatewayName": "Nama Gateway",
        "gatewayCode": "Kode Gateway",
        "environment": "Lingkungan (Environment)",
        "envSandbox": "Sandbox (Simulator Uji Coba)",
        "envProduction": "Production (Jalur Live)",
        "operationalStatus": "Status Operasional",
        "active": "Aktif",
        "inactive": "Nonaktif",
        "clientId": "Client ID / API Key",
        "clientSecret": "Client Secret",
        "show": "Lihat",
        "hide": "Tutup",
        "merchantCode": "Merchant Code",
        "channelId": "Channel ID",
        "endpointUrl": "Endpoint URL (Host-to-Host)",
        "webhookUrl": "Webhook URL",
        "webhookSecret": "Webhook Secret",
        "ipWhitelist": "IP Whitelist",
        "certificateData": "Sertifikat Publik mTLS (PEM)",
        "saveConfig": "Simpan Konfigurasi",
        "saving": "Menyimpan..."
      },
      "diagnostics": {
        "title": "Hasil Uji Koneksi SNAP BI",
        "standardNote": "PADG BI No. 23/15/PADG/2021",
        "handshakeLatency": "Latensi Handshake",
        "encryptionProtocol": "Protokol Enkripsi",
        "cipherSuite": "Cipher Suite",
        "testTimestamp": "Waktu Uji",
        "mandatory": "Wajib"
      },
      "table": {
        "title": "Log Audit & Dispatch Settlement Perbankan",
        "subtitle": "Catatan riil eksekusi transfer dana dari database dst_audit_logs.",
        "colTimestamp": "Waktu",
        "colExecutor": "Eksekutor",
        "colAction": "Aksi",
        "colTarget": "Target / Penerima",
        "colTraceId": "Trace ID",
        "noAuditLogs": "Belum ada riwayat transaksi settlement yang terekam.",
        "settlementBadge": "SETTLEMENT"
      },
      "feedback": {
        "saveSuccess": "Konfigurasi API {{name}} berhasil disimpan ke database!",
        "saveError": "Gagal menyimpan konfigurasi gateway perbankan.",
        "pingSuccess": "Uji handshake berhasil ({{ms}}ms) - Status: ONLINE.",
        "pingError": "Uji coba koneksi API Gateway gagal dihubungi.",
        "loading": "Memuat data integrasi API..."
      }
    },
    "stats": {
      "totalUsers": "Total Pengguna",
      "bypassApproved": "Bypass Disetujui",
      "canAddMembers": "Dapat Tambah Anggota",
      "superAdmins": "Super Admin"
    },
    "searchPlaceholder": "Cari berdasarkan nama, email, peran, atau cabang...",
    "filterLabel": "Filter:",
    "filters": {
      "allUsers": "Semua Pengguna",
      "bypassEnabled": "Bypass Aktif",
      "superAdmins": "Super Admin"
    },
    "table": {
      "userRole": "Pengguna & Peran",
      "branchDept": "Cabang / Departemen",
      "bypassApproval": "Bypass Persetujuan",
      "addMembers": "Tambah Anggota",
      "manageLogs": "Kelola Log",
      "viewReports": "Lihat Laporan",
      "noUsers": "Tidak ada anggota tim yang cocok.",
      "role": "Peran:",
      "globalOffice": "Kantor Pusat",
      "enabled": "AKTIF",
      "disabled": "NONAKTIF",
      "superAdminBadge": "SUPER ADMIN",
      "vipBadge": "VIP"
    },
    "feedback": {
      "updatedPerm": "Izin \"{{key}}\" untuk {{name}} berhasil diubah menjadi {{status}}.",
      "updateFailed": "Gagal memperbarui izin untuk {{name}}.",
      "manualLogRecorded": "Catatan audit manual berhasil disimpan.",
      "logUpdated": "Entri log audit berhasil diperbarui.",
      "logDeleted": "Entri log audit berhasil dihapus secara permanen.",
      "logsLoadFailed": "Gagal memuat log audit sistem. Pastikan Anda login sebagai Super Admin.",
      "deleteFailed": "Gagal menghapus entri log audit."
    },
    "audit": {
      "searchPlaceholder": "Cari log berdasarkan pengguna, aksi, IP, atau rincian...",
      "allActions": "Semua Aksi",
      "filterBypass": "Bypass Konfirmasi",
      "filterPerms": "Perubahan Izin",
      "filterAdminNotes": "Catatan Admin",
      "filterSecurity": "Aktivitas Keamanan",
      "filterSystem": "Perubahan Sistem",
      "addManualLog": "Tambah Log Manual",
      "timestamp": "Waktu",
      "actionEvent": "Jenis Aksi",
      "performedBy": "Dilakukan Oleh",
      "targetEntity": "Entitas Sasaran",
      "remarksDetails": "Rincian Audit / Catatan",
      "actions": "Aksi",
      "loading": "Memuat log audit sistem...",
      "noLogs": "Tidak ada entri log audit yang sesuai dengan kriteria.",
      "editTooltip": "Ubah Catatan Log",
      "deleteTooltip": "Hapus Entri Log",
      "deleteTitle": "Hapus Entri Log Audit?",
      "deleteDesc": "Apakah Anda yakin ingin menghapus permanen ID rekaman audit: {{id}}? Tindakan ini tidak dapat dibatalkan.",
      "confirmDelete": "Ya, Hapus",
      "dismiss": "Tutup",
      "badges": {
        "bypass": "BYPASS KONFIRMASI",
        "updatePerms": "UBAH IZIN",
        "adminNote": "CATATAN ADMIN"
      }
    },
    "modal": {
      "addTitle": "Tambah Log Audit Sistem",
      "editTitle": "Ubah Entri Log Audit",
      "addSubtitle": "Catat catatan operasional audit",
      "editSubtitle": "ID Log: {{id}}",
      "actionLabel": "Jenis Aksi / Peristiwa *",
      "targetLabel": "Pengguna / Entitas Sasaran",
      "targetPlaceholder": "misal: Mr. Khalid, DST-System, finance_token",
      "ipLabel": "Alamat IP (Opsional)",
      "ipPlaceholder": "misal: 187.52.126.215 atau 127.0.0.1",
      "remarksLabel": "Catatan Audit & Rincian *",
      "remarksPlaceholder": "Masukkan catatan terkait jejak audit ini...",
      "save": "Tambah Entri Audit",
      "update": "Simpan Perubahan",
      "saving": "Menyimpan...",
      "options": {
        "manual": "Catatan Administratif Manual",
        "security": "Audit Keamanan & Akses",
        "sysConfig": "Perubahan Konfigurasi Sistem",
        "updatePerms": "Pembaruan Izin Pengguna",
        "financeOverride": "Override Transaksi Keuangan",
        "compliance": "Tinjauan Kepatuhan & Audit"
      },
      "errorEmpty": "Harap berikan rincian atau catatan untuk log audit ini."
    }
  },
  "depositReceipt": {
    "generateTitle": "Buat Kuitansi Resmi Pembayaran Di Muka",
    "generateSubtitle": "Voucher kuitansi kas/bank langsung dengan verifikasi rekening bank kedua belah pihak",
    "receiptTitle": "KUITANSI PEMBAYARAN RESMI",
    "receiptSubtitle": "Kerajaan Arab Saudi / Republik Indonesia",
    "receiptVoucher": "Bukti Penerimaan Kas & Bank",
    "receiptNo": "No. Kuitansi",
    "date": "Tanggal Kuitansi",
    "confirmationDate": "Tanggal Konfirmasi",
    "referenceNo": "No. Referensi",
    "serialNo": "No. Seri",
    "groupNo": "No. Grup",
    "payerInfo": "Informasi Perusahaan Pembayar / Klien",
    "selectRegisteredPayer": "Pilih Perusahaan Terdaftar",
    "orCustomPayer": "Klien Kustom / Sekali Pakai",
    "payerCompanyName": "Nama Perusahaan Pembayar",
    "payerCode": "Kode Perusahaan",
    "payerAgent": "Agen / PIC",
    "payerAddress": "Alamat Perusahaan",
    "payerTaxNumber": "NPWP / No. Registrasi Pajak",
    "payerEmail": "Alamat Email",
    "paymentDetails": "Rincian Transaksi Pembayaran",
    "depositAmount": "Jumlah Pembayaran / DP",
    "currency": "Mata Uang",
    "paymentDate": "Tanggal Pembayaran",
    "paymentMethod": "Metode Pembayaran",
    "forPaymentOf": "Untuk Pembayaran (Tujuan)",
    "purposePlaceholder": "misal: Uang Muka Paket Ground Handling & Akomodasi Hotel",
    "notes": "Catatan Internal / Keterangan",
    "note": "Catatan Tambahan / Referensi",
    "notesPlaceholder": "Catatan tambahan...",
    "dualBankTitle": "Verifikasi Rekening Bank Kedua Belah Pihak",
    "beneficiaryBank": "Rekening Bank Penerima (Perusahaan Kami)",
    "remitterBank": "Rekening Bank Pengirim (Perusahaan Pembayar)",
    "bankName": "Nama Bank",
    "accountName": "Nama Pemilik Rekening",
    "accountNumber": "Nomor Rekening / IBAN",
    "swiftCode": "Kode SWIFT",
    "bankBranch": "Alamat Cabang Bank",
    "branch": "Cabang Bank",
    "paymentProof": "Bukti Transfer / Pembayaran",
    "uploadProofDesc": "Lampirkan foto transfer atau dokumen PDF",
    "dropFileHere": "Klik atau seret bukti transfer ke sini",
    "previewProof": "Lihat Bukti",
    "removeProof": "Hapus",
    "submitGenerate": "Buat & Lihat Kuitansi Resmi",
    "generating": "Menerbitkan Kuitansi...",
    "receivedFrom": "Telah Diterima Dari",
    "amountInWords": "Terbilang",
    "amountReceived": "Jumlah Diterima",
    "settlementSummary": "Rincian Bank & Setelmen",
    "authorizedSignature": "Petugas Keuangan Berwenang",
    "stampAndSeal": "Stempel Resmi Perusahaan",
    "printPdf": "Cetak / Simpan PDF",
    "close": "Tutup",
    "language": "Bahasa Kuitansi",
    "english": "Bahasa Inggris",
    "indonesian": "Bahasa Indonesia",
    "arabic": "Bahasa Arab",
    "statusValid": "Status Formulir: Lengkap & Terverifikasi",
    "errAmount": "Harap masukkan jumlah nominal yang valid di atas 0",
    "errPayer": "Harap pilih atau masukkan nama perusahaan pembayar",
    "errBank": "Harap lengkapi rincian rekening bank pengirim dan penerima",
    "errProofSize": "Ukuran file melebihi batas maksimal 10MB",
    "successGenerated": "Kuitansi pembayaran di muka resmi berhasil dibuat!"
  }
}

